import firebase from "firebase";

export const getUuidUrlParamMatcher = (urlParam: string) =>
    `:${urlParam}([0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12})`;

interface NameInterface {
    salutation: string;
    firstName: string;
    lastName: string;
    companyName?: string;
}

export function getFullName<T extends NameInterface>(v: T, salutation = true) {
    return `${salutation ? `${v.salutation} ` : ""}${v.firstName} ${v.lastName}${v.companyName ? ` (${v.companyName})` : ""}`
}

export const replaceUndefinedWithDelete = (data: Record<string, any>) => {
    return Object.fromEntries(
        Object
            .entries(data)
            .map(([key, value]) =>
                [key, value === undefined ? firebase.firestore.FieldValue.delete() : value]
            )
    )
}